import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {
  @Input() typeToast: number = 0;
  @Input() showToast: boolean = false;
  @Input() messageToast: string = '';
  @Output() closeToast: EventEmitter<any> = new EventEmitter();

  constructor(
  ) { }

  async ngOnInit() {
  }

  close() {
    this.closeToast.emit()
  }
}
